module.exports = __webpack_public_path__ + "static/5-c58c4a81acf90a71564b9e69e64b381a.png";